import { createStore, select, withProps } from '@ngneat/elf';

const appStore = createStore(
  {
    name: 'app',
  },
  withProps({ loadingApp: true }),
);

class AppStore {
  constructor() {
    this.loadingApp$ = appStore.pipe(select(state => state.loadingApp));
  }

  loadingApp(loading) {
    appStore.update(state => ({
      ...state,
      loadingApp: loading,
    }));
  }
}

export const appStoreService = new AppStore();
